<template>
	<div class="container page">
		<van-nav-bar :title="$t('setting.fill_bank')" class="nav-bar">
			<template #left>
				<van-icon name="arrow-left" color="#fff" @click="back()" />
			</template>
		</van-nav-bar>
		<div class="main-box">
			<div class="label">{{$t("setting.fill_bank_tip")}}</div>
			<van-cell-group>
				<van-field v-model="username" :label="$t('setting.username')" :placeholder="$t('setting.username')" />
				<van-field v-model="bank" :label="$t('setting.band_name')" :placeholder="$t('setting.band_name')" />
				<!-- <van-field v-model="bankfenhang" :label="$t('setting.branch_name')"
					:placeholder="$t('setting.branch_name_tip')" />
				<van-field v-model="fhnumber" :label="$t('setting.branch_code')"
					:placeholder="$t('setting.branch_code_tip')" /> -->
				<!-- <van-field v-model="bankid" :label="$t('setting.band_account')" type="digit"
					:placeholder="$t('setting.band_account_tip')" /> -->
				<van-field v-model="bankid" :label="'IBAN'" :placeholder="'IBAN'" />
			</van-cell-group>
			<p>{{$t("setting.bank_warn")}}</p>
		</div>
		<van-button class="bindCard" type="default" @click="bindCard()">{{$t("setting.bank_ok")}}</van-button>

	</div>
</template>

<script>
	export default {
		data() {
			return {
				banks: [],
				bankid: "",
				username: "",
				mobile: "",
				bank: "",
				bank_code: "",
				bankfenhang: '',
				fhnumber: ""
			};
		},
		created() {},
		methods: {
			back() {
				return window.history.back();
			},
			bindCard() {
				this.$http({
					method: 'post',
					data: {
						realname: this.username,
						bankname: this.bank,
						account: this.bankid,
					},
					url: 'bankBind'
				}).then(res => {
					if (res.code == 1) {
						this.$router.push({
							path: '/Mine'
						})
						this.$toast(res.msg);
					} else {
						this.$toast(res.msg);
					}
				})
			},
		},

	};
</script>

<style lang='less' scoped>
	@import "../../assets/css/base.css";

	.nav-bar {
		background: linear-gradient(90deg, #f905e5, #e6c3a1);
	}

	.van-cell {
		font-size: 32px;
		line-height: 80px;
	}

	.van-hairline--bottom::after {
		border-bottom-width: 3px;
	}

	.bankbox {
		padding: 15px;
		color: #000;
		background-color: #fff;
	}

	.bankbox .title {
		padding: 8px 10px 20px;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		font-size: 28px;
	}

	.main-box {
		background: #fff;

	}

	.main-box .label {
		padding: 20px;
		font-size: 35px;
		color: #797878;
	}

	::v-deep .van-picker__toolbar {
		height: 50px;
	}

	::v-deep .van-picker__cancel,
	.van-picker__confirm {
		padding: 0 20px;
		font-size: 20px;
	}

	::v-deep .van-picker-column {
		font-size: 40px;
	}

	.main-box p {
		padding: 0 20px;
		font-size: 30px;
		color: #ee0a24;
	}

	.bindCard {
		margin: 20px 30px 0;
		padding: 20px 0;
		border-radius: 50px;
		color: #fff;
		font-size: 30px;
		font-weight: bolder;
		border: none;
		background: linear-gradient(90deg, #e6c3a1, #7e5678);
	}
</style>